import { useMemo } from "react";

export default ({
  postType,
  taxParams,
  metaParams,
  dateParams,
  categoryTermExclude,
  categoryTermInclude,
}) =>
  useMemo(() => {
    const params = {
      post_type: postType,
    };

    if (taxParams) {
      Object.keys(taxParams).forEach((taxSlug) => {
        params[`tax_${taxSlug}`] = taxParams[taxSlug];
      });
    }

    if (metaParams) {
      Object.keys(metaParams).forEach((metaKey) => {
        params[`meta_${metaKey}`] = metaParams[metaKey];
      });
    }

    if (categoryTermExclude) {
      params["category_term_exclude"] = categoryTermExclude;
    }

    if (categoryTermInclude) {
      params["category_term_include"] = categoryTermInclude;
    }

    if (dateParams) {
      dateParams.forEach((dateParam) => {
        if (dateParam === 0) return;

        const date = new Date(dateParam);

        params["year"] = date.getFullYear();
        params["monthnum"] = date.getMonth() + 1; // js indexes months from 0
      });
    }

    return params;
  }, [postType, taxParams, metaParams]);
